import { SelectComponent } from './selectComponent/select.component';
import { PushComponent } from './pushComponent/push.component';
import { LicenseAttributeConfigurationComponent } from './licenseAttributeConfigurationComponent/license-attribute-configuration.component';
import { AddLicensesComponent } from './addLicensesComponent/add-licenses.component';
import { AddCompanyComponent } from './addCompanyComponent/add-company.component';
import { LicenseDetailsComponent } from './licenseDetailsComponent/license-details.component';
import { LicensesComponent } from './licensesComponent/licenses.component';
import { CompanyDetailsComponent } from './companyDetailsComponent/company-details.component';
import { CompaniesComponent } from './companiesComponent/companies.component';
import { EditLicenseComponent } from './editLicenseComponent/edit-license.component';
import { SimpleOptionPopoverComponent } from './licensesComponent/simple-option-popover.component';
import { CompanyLicenseSettingsComponent } from './companyLicenseSettingsComponent/company-license-settings.component';
import { ResetLicenseComponent } from './resetLicenseComponent/reset-license.component';

const CLM_COMPONENTS: any[] = [
    CompaniesComponent,
    CompanyDetailsComponent,
    LicensesComponent,
    LicenseDetailsComponent,
    AddCompanyComponent,
    AddLicensesComponent,
    LicenseAttributeConfigurationComponent,
    EditLicenseComponent,
    SimpleOptionPopoverComponent,
    CompanyLicenseSettingsComponent,
    PushComponent,
    ResetLicenseComponent,
    SelectComponent
];
const CLM_MODELS: any[] = [];
const CLM_PROVIDERS: any[] = [];

export {
    CLM_MODELS,
    CLM_PROVIDERS,
    CLM_COMPONENTS,

    CompaniesComponent,
    CompanyDetailsComponent,
    LicensesComponent,
    LicenseDetailsComponent,
    AddCompanyComponent,
    AddLicensesComponent,
    LicenseAttributeConfigurationComponent,
    EditLicenseComponent,
    CompanyLicenseSettingsComponent,
    PushComponent,
    ResetLicenseComponent,
    SelectComponent
};



// WEBPACK FOOTER //
// ./src/app/features/companyLicenseManagement/companyLicenseManagement.ts